import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(() => ({

    paperV1: {
        borderRadius: '8px !important',
        maxWidth: '390px !important'
    },
    closeIconV1: {
        fontSize: '18px'
    },
    dialogContentV1: {
        padding: '16px !important',
        paddingTop: '0px !important',
        marginTop: "-12px",
        paddingBottom: "24px !important"
    },
    textV1: {
        fontSize: '16px',
        textAlign: 'center',
        fontWeight: "300",
        marginTop: "10px"
    },
    fwBold: {
        fontWeight: 'bold !important'
    },
    textV2: {
        fontWeight: 'bold',
        fontSize: "18px"
    },
    dialogTitleV1: {
        paddingTop: '0px !important',
        paddingBottom: '0px !important',
        paddingLeft: '0xp !important',
        paddingRight: '0px !important',
        display: 'flex',
        justifyContent: 'end'
    }

}))

const SimpleKhataLoginDialog = ({ open, onClose }) => {

    const classes = useStyles()

    const [ dialogOpen, setDialogOpen ] = useState(open)

    const handleClose = () => {
        setDialogOpen(false)
        onClose()
    }

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} 
                aria-labelledby="simple-khata-login-details" open={dialogOpen}
                classes={{ paperScrollPaper: classes.paperV1 }}
            >
                <DialogTitle className={classes.dialogTitleV1}>
                    <IconButton onClick={handleClose}>
                        <CloseIcon className={classes.closeIconV1} />
                    </IconButton>
                </DialogTitle>
                <DialogContent className={classes.dialogContentV1}>
                    <div className={classes.textV1}>
                        Sorry! We are not supporting new users to Desktop. Please contact 
                        support <span className={classes.textV2}>08046802342</span> for more details.
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )

}

export default SimpleKhataLoginDialog;